<script setup lang="ts">
import EpaperIconBlock from './EpaperIconBlock.vue'
import EpaperCalendarSvg from '@/assets/img/epaper-calendar.svg'
import EpaperInfoSvg from '@/assets/img/epaper-info.svg'
const { t } = useTranslation()
</script>

<template>
  <div>
    <EpaperIconBlock>
      <div
        m-auto
      >
        <IaThemeIcon
          size="2xl"
          class="text-grey-800"
        >
          <EpaperInfoSvg />
        </IaThemeIcon>
      </div>
      <div
        m-auto
        font-500
      >
        {{ t('epaper.landingPage.iconBlock.1') }}
      </div>
    </EpaperIconBlock>

    <EpaperIconBlock>
      <div m-auto>
        <IaThemeIcon
          icon="i-fas:paper-plane"
          size="2xl"
          class="text-grey-800"
        />
      </div>
      <div
        m-auto
        font-500
      >
        {{ t('epaper.landingPage.iconBlock.2') }}
      </div>
    </EpaperIconBlock>

    <EpaperIconBlock>
      <div m-auto>
        <IaThemeIcon
          size="2xl"
          class="text-grey-800"
        >
          <EpaperCalendarSvg />
        </IaThemeIcon>
      </div>
      <div
        m-auto
        font-500
      >
        {{ t('epaper.landingPage.iconBlock.3') }}
      </div>
    </EpaperIconBlock>
  </div>
</template>
